import {Setting, SettingType} from "../SettingsApi";
import SettingModal
  from "@/pages/SystemAdmin/Settings/_private/modals/SettingModal";
import SettingModalDelete
  from "@/pages/SystemAdmin/Settings/_private/modals/SettingModalDelete";
import {
  openModal,
  refreshSettings
} from "@/pages/SystemAdmin/Settings/_private/init.ts";
import {ModalSize, RowAction, TableColumn} from "@fs/uikit-react";

export const getTableColumns = (): TableColumn[] => {
  return [
    {
      key: 'scope',
      title: 'Область',
      width: '20%',
      sortable: true,
    },
    {
      key: 'key',
      title: 'Ключ',
      width: '25%',
      sortable: true,
    },
    {
      key: 'valueType',
      title: 'Тип',
      width: '15%',
    },
    {
      key: 'valueText',
      title: 'Значення',
      width: '40%',
      render: (text: string, record: Setting) => {
        return record.valueType === SettingType.SECRET ? '******' : text;
      }
    }
  ];
}

export const getRowActions = (handleDeleteSetting: (record: Setting) => void): RowAction[] => {
  return [
    {
      type: 'delete',
      onClick: (record: Setting) => {
        handleDeleteSetting(record);
      }
    }
  ];
}

export const filteredSettings = (settings: Setting[], searchValue: string): Setting[] => {

  if (searchValue === '') {
    return settings;
  }

  const searchLower = searchValue.toLowerCase();
  return settings.filter(setting => (
    setting.scope.toLowerCase().includes(searchLower) ||
    setting.key.toLowerCase().includes(searchLower) ||
    setting.valueType.toLowerCase().includes(searchLower) ||
    setting.valueText.toLowerCase().includes(searchLower) ||
    (setting.description?.toLowerCase().includes(searchLower))
  ));
};

export const handleCreateSetting = () => {
  openModal(
    ModalSize.SMALL,
    'Створити налаштування',
    <SettingModal onSuccess={refreshSettings}/>
  );
}

export const handleEditSetting = (setting: Setting) => {
  openModal(
    ModalSize.SMALL,
    'Редагувати налаштування',
    <SettingModal setting={setting} onSuccess={refreshSettings}/>
  );
};

export const handleDeleteSetting = (setting: Setting) => {
  openModal(
    ModalSize.SMALL,
    'Видалити налаштування',
    <SettingModalDelete setting={setting} onSuccess={refreshSettings}/>
  );
};
